export const environment = {
  production: true,
  homologation: false,
  api: 'https://orcamento.parnamirim.rn.gov.br/api/v1',
};
